const reasons = [
  {
    icon: 'ri-medal-line',
    title: 'ACHC Certified Consultant',
    desc: 'Led by a credentialed ACHC Certified Consultant with deep, verified expertise in accreditation standards.',
  },
  {
    icon: 'ri-hospital-line',
    title: 'Real Home Health Industry Experience',
    desc: 'Hands-on operational knowledge of home health agencies — we\'ve been in the field, not just the classroom.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Faster Accreditation Process',
    desc: 'Our proven methodology eliminates delays and streamlines every step so you achieve accreditation faster.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Full Compliance System Setup',
    desc: 'We build your entire compliance infrastructure — policies, procedures, tracking systems, and documentation.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Personalized Support',
    desc: 'Dedicated one-on-one guidance tailored to your agency\'s unique needs, size, and operational goals.',
  },
];

export default function WhySection() {
  return (
    <section className="bg-[#111111] py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-[#d4af37]"></div>
              <span className="text-[#d4af37] text-xs uppercase tracking-[3px] font-semibold">Why Advantixx</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-white leading-tight mb-6">
              The Advantage
              <br />
              <span className="text-[#d4af37]">You Need</span>
            </h2>
            <p className="text-[#888] text-base leading-relaxed mb-8 max-w-md">
              We don&apos;t just prepare you for accreditation — we give you the systems, knowledge, and confidence to operate at the highest level of quality and performance.
            </p>
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/0609d4f16600bb53ae7176469b82f15e.jpg"
                alt="Advantixx consultant at work"
                className="w-full h-64 object-cover object-top rounded-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/60 to-transparent rounded-2xl"></div>
              <div className="absolute bottom-5 left-5 bg-[#d4af37] text-[#0d0d0d] text-xs font-bold px-4 py-2 rounded-full">
                ACHC Certified
              </div>
            </div>

            {/* ACHC Certified Consultant badge — per ACHC brand guidelines */}
            <a
              href="https://www.achc.org/certified-consultants.html"
              target="_blank"
              rel="nofollow noreferrer"
              className="mt-6 flex items-center gap-5 bg-white/5 border border-white/10 rounded-xl px-5 py-4 hover:bg-white/8 hover:border-white/20 transition-all duration-300 cursor-pointer group"
              title="ACHC Certified Consultant — Verify on ACHC.org"
            >
              <img
                src="https://storage.readdy-site.link/project_files/08c9742b-b998-4dd6-add2-07c3775679f4/3bc5c37e-5171-4cc8-96c1-cd12362a392c_ACHC-Certified-Consultant.png?v=6711ad00855061fc6dd29608e2540a8b"
                alt="ACHC Certified Consultant"
                className="h-10 w-auto object-contain shrink-0"
              />
              <div className="flex-1">
                <p className="text-white font-bold text-sm">ACHC Certified Consultant</p>
                <p className="text-[#888] text-xs mt-0.5">CMS Deeming Authority — Quality &amp; Excellence Since 1986</p>
              </div>
              <i className="ri-external-link-line text-white/30 text-sm group-hover:text-white/60 transition-colors duration-200"></i>
            </a>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-6">
            {reasons.map((reason) => (
              <div
                key={reason.title}
                className="flex items-start gap-5 group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl border border-[#d4af37]/30 bg-[#d4af37]/5 group-hover:bg-[#d4af37]/15 transition-colors duration-300 shrink-0">
                  <i className={`${reason.icon} text-[#d4af37] text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-base mb-1">{reason.title}</h3>
                  <p className="text-[#888] text-sm leading-relaxed">{reason.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
